import { render, staticRenderFns } from "./CatalogList.vue?vue&type=template&id=1b9b8b4a&"
import script from "./CatalogList.vue?vue&type=script&lang=js&"
export * from "./CatalogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports